import { ConservationBenchmarkType, Fact } from '@/api/rest/resources/conservation';
import { isNullish } from '@/utils/booleans';

export const getBenchmarkForConservationFact = ({
  fact,
  benchmarks,
}: {
  fact: Fact | { value: number | null };
  benchmarks: Record<ConservationBenchmarkType, number>;
}) => {
  if (isNullish(fact) || isNullish(fact.value)) {
    return null;
  }

  const factValue = Number(fact.value);

  if (factValue >= benchmarks.thriving) {
    return ConservationBenchmarkType.thriving;
  }

  if (factValue >= benchmarks.healthy) {
    return ConservationBenchmarkType.healthy;
  }

  if (factValue >= benchmarks.managing) {
    return ConservationBenchmarkType.managing;
  }

  if (factValue >= benchmarks.fragile) {
    return ConservationBenchmarkType.fragile;
  }

  return ConservationBenchmarkType.degraded;
};
